/*
  Bulk upload appointments status
 */

import { Request } from "mssql";
import { ApplicationScope } from "../ApplicationScope";
import * as csv from 'json2csv';
import { R4ApptFlags } from "../R4Patient";

export const bulkUploadAppointmentStatus = async (applicationScope: ApplicationScope) => {
  try {
    const req: Request = await applicationScope.connectionPool.request();
    applicationScope.logging.log({
      message: `Appointment status bulk upload trigger`
    });

    const result = await req.query(`select ApptFlag, Description, Character, Cancelled from ApptFlags`);
    if (result.recordset.length === 0) {
      applicationScope.logging.log({
        message: 'No appointment status found for bulk upload!'
      });
      return;
    }

    const csvData: R4ApptFlags[] = result.recordset.map(row => {
      return {
        apptFlag: Number(row['ApptFlag']),
        cancelled: Boolean(row['Cancelled']),
        character: row['Character'].toString(),
        description: row['Description'].toString()
      }
    });

    const csvText = csv.parse(csvData, { header: true });
    await applicationScope.flynotesServer.appointmentStatusBulkUpload(csvText, applicationScope.licenceKey);
    applicationScope.logging.log({
      message: `Done sync appointment status bulk upload`
    });    
  } catch (e) {
    applicationScope.logging.log({
      message: `Appointment status bulk upload failed ${e}`,
      error: e
    }, 'error')
  }
};